import React, { useCallback, useEffect, useRef } from 'react';
import { Textarea, TextareaValueData } from '@fluentai/textarea';

export interface PromptProps {
  value: string;
  placeholder: string;
  disabled?: boolean;
  onChange: (newValue: string) => void;
  onSubmit: () => void;
}

export const Prompt: React.FC<PromptProps> = (props) => {
  const {
    value,
    placeholder,
    disabled,
    onChange,
    onSubmit,
  } = props;

  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    // istanbul ignore next
    if (!textareaRef.current) { return; }

    // istanbul ignore next
    setTimeout(() => textareaRef.current?.focus(), 100);
  }, []);

  const handleChange = useCallback((_ev: React.FormEvent<HTMLTextAreaElement>, data: TextareaValueData) => {
    onChange(data.value);
  }, [onChange]);

  const handleKeyDown = useCallback((evt: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (evt.key === 'Enter' && !evt.shiftKey) {
      // only Shift+Enter can insert a new line
      evt.preventDefault();
    }
  }, []);

  const handleKeyUp = useCallback((evt: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (evt.key === 'Enter' && !evt.shiftKey) {
      onSubmit();
    }
  }, [onSubmit]);

  return (
    <Textarea
      ref={textareaRef}
      value={value}
      placeholder={placeholder}
      maxLength={300}
      disabled={disabled}
      send={{ disabled: disabled || !value.trim() }}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      onKeyUp={handleKeyUp}
      onSubmit={onSubmit}
    />
  );
};

Prompt.defaultProps = {
  disabled: false,
};
